import * as z from "zod/v4";

export const startAllUnifiedBillingMigrations = {
  name: "startAllUnifiedBillingMigrations" as const,
  input: z.object({}),
  output: z.object({ count: z.number() }),
};
